import { t } from "i18next";

import TitledPage from "@/modules/common/components/layout/pages/TitledPage";

const SolutionsPage = () => {
  return <TitledPage title={t("Admin Solutions")}></TitledPage>;
};

export default SolutionsPage;
